import { useEffect, useCallback } from 'react';
import useApi from './useApi';
import { SafetyHazardItem } from '../types/SafetyHazardTypes';
import { useAppSettings } from '../hooks/useAppSettings';

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getSafetyHazards = useCallback(async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            await getApiData({
                endpoint: `${apiUrl}/GetSafetyHazards`,
            });
        } catch (error) {
            console.error('Failed to fetch safety hazards:', error);
        }
    }, [getApiData]);

    useEffect(() => {
        if (state.status === 'success' && state.result) {
            try {
                console.log('Safety Hazards API Response:', state.result);
                console.log('Safety Hazards API Response type:', typeof state.result);
                console.log('Is array?', Array.isArray(state.result));
            } catch (error) {
                console.error('Error processing safety hazards:', error);
            }
        }
    }, [state.status, state.result]);

    // Get the safety hazards data
    const getSafetyHazardsData = (): SafetyHazardItem[] => {
        if (state.status === 'success' && state.result) {
            let rawSafetyHazards: any[] = [];
            if (Array.isArray(state.result)) {
                rawSafetyHazards = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                rawSafetyHazards = state.result.data;
            } else if (typeof state.result === 'object') {
                rawSafetyHazards = [state.result];
            }
            return rawSafetyHazards;
        }
        return [];
    };

    return {
        safetyHazards: getSafetyHazardsData(),
        loading: state.isLoading,
        error: state.error,
        getSafetyHazards,
        status: state.status,
    };
};
